import {
  DEFAULT_ROUTE_COLOR_OBJECT,
  MapConst,
  TrackingTrailLegendSwatchStyleEnum,
} from "@ryde/shared";

export interface ITrackingTrailLegendRow {
  /** i18n key for the row label (also used as the React key). */
  labelKey: string;
  /** Line style of the swatch, matching how the map renders this trail state. */
  swatchStyle: TrackingTrailLegendSwatchStyleEnum;
  /** Swatch color, sourced from the same constants the trail renders with. */
  color: string;
}

/**
 * Legend rows, each mirroring a state the live map actually renders: planned route (solid, route color),
 * real GPS (dashed, route color), no signal (grey sparse dots — a >2-min gap is an interpolated straight
 * line), and detour (red). Kept in sync with `resolveMergedTrailSegmentStyle` (GPS trail) and the
 * planned-route `Polyline`. The planned-route and real-GPS swatches use the default route color as a
 * representative sample, since each ride draws in its own color.
 */
export const TRACKING_TRAIL_LEGEND_ROWS: ITrackingTrailLegendRow[] = [
  {
    labelKey: "rideMap.LEGEND_PLANNED_ROUTE",
    swatchStyle: TrackingTrailLegendSwatchStyleEnum.solid,
    color: DEFAULT_ROUTE_COLOR_OBJECT.colorValue,
  },
  {
    labelKey: "rideMap.LEGEND_REAL_GPS",
    swatchStyle: TrackingTrailLegendSwatchStyleEnum.dashed,
    color: DEFAULT_ROUTE_COLOR_OBJECT.colorValue,
  },
  {
    labelKey: "rideMap.LEGEND_NO_SIGNAL",
    swatchStyle: TrackingTrailLegendSwatchStyleEnum.dotted,
    color: MapConst.DASHED_LINE_COLOR,
  },
  {
    labelKey: "rideMap.LEGEND_DETOUR",
    swatchStyle: TrackingTrailLegendSwatchStyleEnum.dashed,
    color: MapConst.GPS_TRAIL_DETOUR_COLOR,
  },
];
